import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {BindingOrdersActions} from '../store';
import {BindingOrdersSelectors} from '../store/selectors';

@Injectable()
export class BindingOrdersLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadBindingOrdersDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadBindingOrdersDone() {
    return this.store.pipe(
      select(BindingOrdersSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(BindingOrdersActions.ReadBindingOrders());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
